import { defineMessages } from 'react-intl';

/** The script step (design directed-video e1, e2, j3). */
export const scriptMessages = defineMessages({
  title: { id: 'app.sml.musicVideo.directed.script.title', defaultMessage: 'Read the script' },
  intro: {
    id: 'app.sml.musicVideo.directed.script.intro',
    defaultMessage:
      '{count, plural, one {# shot} other {# shots}} from the first second to the last. Change a shot, remove it, add one, or ask the director to write a shot or the whole script again.',
  },
  introShort: {
    id: 'app.sml.musicVideo.directed.script.introShort',
    defaultMessage: '{count, plural, one {# shot} other {# shots}} from the first second to the last.',
  },
  noScript: {
    id: 'app.sml.musicVideo.directed.script.none',
    defaultMessage: 'The director has no script for this video yet.',
  },
  writeScript: { id: 'app.sml.musicVideo.directed.script.write', defaultMessage: 'Write the script' },
  rewriteAll: { id: 'app.sml.musicVideo.directed.script.rewriteAll', defaultMessage: 'Rewrite the whole script' },

  // The strip
  stripLabel: { id: 'app.sml.musicVideo.directed.script.strip', defaultMessage: 'The script against the song' },
  laneSections: { id: 'app.sml.musicVideo.directed.script.laneSections', defaultMessage: 'Sections' },
  laneShots: { id: 'app.sml.musicVideo.directed.script.laneShots', defaultMessage: 'Shots' },
  laneEffects: { id: 'app.sml.musicVideo.directed.script.laneEffects', defaultMessage: 'Effects' },
  laneSong: { id: 'app.sml.musicVideo.directed.script.laneSong', defaultMessage: 'Song' },
  shotBox: { id: 'app.sml.musicVideo.directed.script.shotBox', defaultMessage: 'Shot {number}, {from} to {to}' },
  stripTip: { id: 'app.sml.musicVideo.directed.script.stripTip', defaultMessage: '{name}, {from} to {to}' },
  zoomIn: { id: 'app.sml.musicVideo.directed.script.zoomIn', defaultMessage: 'Zoom in' },
  zoomOut: { id: 'app.sml.musicVideo.directed.script.zoomOut', defaultMessage: 'Zoom out' },
  zoomLevel: { id: 'app.sml.musicVideo.directed.script.zoomLevel', defaultMessage: '{zoom}×' },
  legendLabel: { id: 'app.sml.musicVideo.directed.script.legendLabel', defaultMessage: 'Effect colours' },

  // One row
  clip: { id: 'app.sml.musicVideo.directed.script.clip', defaultMessage: 'Clip {number}' },
  clipIn: { id: 'app.sml.musicVideo.directed.script.clipIn', defaultMessage: 'Clip {number} · {seconds} s in' },
  partOfClip: { id: 'app.sml.musicVideo.directed.script.partOfClip', defaultMessage: 'part of clip {number}' },
  noNewShot: {
    id: 'app.sml.musicVideo.directed.script.noNewShot',
    defaultMessage: '{camera} · uses a part of clip {number}, no new shot',
  },
  noNewShotNoCamera: {
    id: 'app.sml.musicVideo.directed.script.noNewShotNoCamera',
    defaultMessage: 'Uses a part of clip {number}, no new shot',
  },
  editShot: { id: 'app.sml.musicVideo.directed.script.editShot', defaultMessage: 'Edit shot {number}' },
  rewriteShotAria: {
    id: 'app.sml.musicVideo.directed.script.rewriteShotAria',
    defaultMessage: 'Rewrite shot {number}',
  },
  removeShotAria: { id: 'app.sml.musicVideo.directed.script.removeShotAria', defaultMessage: 'Remove shot {number}' },
  moreAria: { id: 'app.sml.musicVideo.directed.script.moreAria', defaultMessage: 'More for shot {number}' },
  addHere: { id: 'app.sml.musicVideo.directed.script.addHere', defaultMessage: '+ Add a shot here' },
  newShot: { id: 'app.sml.musicVideo.directed.script.newShot', defaultMessage: 'New' },
  rewriting: {
    id: 'app.sml.musicVideo.directed.script.rewriting',
    defaultMessage: 'The director is writing this shot again: “{note}”…',
  },
  rewritingNoNote: {
    id: 'app.sml.musicVideo.directed.script.rewritingNoNote',
    defaultMessage: 'The director is writing this shot again…',
  },
  removeAsk: {
    id: 'app.sml.musicVideo.directed.script.removeAsk',
    defaultMessage: 'Remove shot {number}? Shot {previous} grows to fill {from}–{to}.',
  },
  removeAskFirst: {
    id: 'app.sml.musicVideo.directed.script.removeAskFirst',
    defaultMessage: 'Remove shot {number}? Shot {next} starts at {from}.',
  },
  removeAskOnly: {
    id: 'app.sml.musicVideo.directed.script.removeAskOnly',
    defaultMessage: 'Remove shot {number}? Its time stays empty.',
  },
  removePrice: {
    id: 'app.sml.musicVideo.directed.script.removePrice',
    defaultMessage: 'One new shot less: the price goes down by {credits} credits.',
  },
  removeNoPrice: {
    id: 'app.sml.musicVideo.directed.script.removeNoPrice',
    defaultMessage: 'The price stays the same: this shot uses a part of another shot.',
  },
  keep: { id: 'app.sml.musicVideo.directed.script.keep', defaultMessage: 'Keep' },
  remove: { id: 'app.sml.musicVideo.directed.script.remove', defaultMessage: 'Remove' },
  onlyShot: {
    id: 'app.sml.musicVideo.directed.script.onlyShot',
    defaultMessage: 'The script needs at least one shot.',
  },

  // The editor of a shot
  whatHappens: { id: 'app.sml.musicVideo.directed.script.whatHappens', defaultMessage: 'What happens' },
  camera: { id: 'app.sml.musicVideo.directed.script.camera', defaultMessage: 'Camera' },
  castInShot: {
    id: 'app.sml.musicVideo.directed.script.castInShot',
    defaultMessage: 'Cast in this shot · {count} of {max}',
  },
  prompt: {
    id: 'app.sml.musicVideo.directed.script.prompt',
    defaultMessage: 'Prompt for the AI · written from your text',
  },
  effects: { id: 'app.sml.musicVideo.directed.script.effects', defaultMessage: 'Effects' },
  effectChip: { id: 'app.sml.musicVideo.directed.script.effectChip', defaultMessage: '{name} · {from}–{to}' },
  saveShot: { id: 'app.sml.musicVideo.directed.script.saveShot', defaultMessage: 'Save the shot' },
  cancel: { id: 'app.sml.musicVideo.directed.script.cancel', defaultMessage: 'Cancel' },
  shotNote: { id: 'app.sml.musicVideo.directed.script.shotNote', defaultMessage: 'Note: closer on her face' },
  rewriteShot: { id: 'app.sml.musicVideo.directed.script.rewriteShot', defaultMessage: 'Rewrite this shot' },
  emptyScene: {
    id: 'app.sml.musicVideo.directed.script.emptyScene',
    defaultMessage: 'Write what happens in this shot.',
  },

  // The phone sheet (j3)
  sheetTitle: { id: 'app.sml.musicVideo.directed.script.sheetTitle', defaultMessage: 'Shot {number}' },
  sheetEdit: { id: 'app.sml.musicVideo.directed.script.sheetEdit', defaultMessage: 'Edit the shot' },
  sheetAdd: { id: 'app.sml.musicVideo.directed.script.sheetAdd', defaultMessage: 'Add a shot after it' },
  sheetClose: { id: 'app.sml.musicVideo.directed.script.sheetClose', defaultMessage: 'Close' },
  sectionAt: { id: 'app.sml.musicVideo.directed.script.sectionAt', defaultMessage: '{section} · {time}' },
  rowEdited: { id: 'app.sml.musicVideo.directed.script.rowEdited', defaultMessage: 'edited' },

  // The stale save (e2)
  stale: {
    id: 'app.sml.musicVideo.directed.script.stale',
    defaultMessage:
      '<b>The script changed in another tab.</b> We loaded the new script. Your text for shot {number} is kept:',
  },
  staleGone: {
    id: 'app.sml.musicVideo.directed.script.staleGone',
    defaultMessage:
      '<b>The script changed in another tab.</b> We loaded the new script. The shot you edited is no longer in it.',
  },
  putTextBack: { id: 'app.sml.musicVideo.directed.script.putTextBack', defaultMessage: 'Put my text back' },

  // The foot
  backToStyle: { id: 'app.sml.musicVideo.directed.script.backToStyle', defaultMessage: 'Back to the style' },
  priceLineSeconds: {
    id: 'app.sml.musicVideo.directed.price.lineSeconds',
    defaultMessage:
      '{count, plural, one {# new clip} other {# new clips}} · {seconds} s of new footage = {total} credits',
  },
  seePrice: { id: 'app.sml.musicVideo.directed.script.seePrice', defaultMessage: 'See the price' },
  seePricePhone: {
    id: 'app.sml.musicVideo.directed.script.seePricePhone',
    defaultMessage: 'See the price · {total} credits',
  },

  // The side panel (e1)
  sideTitle: { id: 'app.sml.musicVideo.directed.script.sideTitle', defaultMessage: 'The script' },
  factShots: { id: 'app.sml.musicVideo.directed.script.factShots', defaultMessage: 'Shots' },
  factNewShots: { id: 'app.sml.musicVideo.directed.script.factNewShots', defaultMessage: 'New shots' },
  factNewShotsValue: {
    id: 'app.sml.musicVideo.directed.script.factNewShotsValue',
    defaultMessage: '{count} · {reused, plural, one {# shot uses} other {# shots use}} a part of another shot',
  },
  factLength: { id: 'app.sml.musicVideo.directed.script.factLength', defaultMessage: 'Length' },
  factLengthWhole: {
    id: 'app.sml.musicVideo.directed.script.factLengthWhole',
    defaultMessage: '{length}, the whole song',
  },
  factEffects: { id: 'app.sml.musicVideo.directed.script.factEffects', defaultMessage: 'Effects' },
  factLyrics: { id: 'app.sml.musicVideo.directed.script.factLyrics', defaultMessage: 'Lyric moments' },
  styleInPrompt: {
    id: 'app.sml.musicVideo.directed.script.styleInPrompt',
    defaultMessage: 'Goes into the prompt of every shot.',
  },
  styleEffects: { id: 'app.sml.musicVideo.directed.script.styleEffects', defaultMessage: 'Effects of the style' },
  styleNoLyrics: {
    id: 'app.sml.musicVideo.directed.script.styleNoLyrics',
    defaultMessage: 'Lyric moments are off in the style, so the script has none. Change it in the style step.',
  },
  effectColours: { id: 'app.sml.musicVideo.directed.script.effectColours', defaultMessage: 'Effect colours' },
  colourTitles: { id: 'app.sml.musicVideo.directed.script.colourTitles', defaultMessage: 'Titles, shot effects' },
  colourTransitions: { id: 'app.sml.musicVideo.directed.script.colourTransitions', defaultMessage: 'Transitions' },
  colourLyrics: { id: 'app.sml.musicVideo.directed.script.colourLyrics', defaultMessage: 'Lyrics' },
  sideHint: {
    id: 'app.sml.musicVideo.directed.script.sideHint',
    defaultMessage:
      'The price follows the number of new shots. Edit as much as you like: nothing is charged before you confirm.',
  },
  rewriteAllTitle: {
    id: 'app.sml.musicVideo.directed.script.rewriteAllTitle',
    defaultMessage: 'Rewrite the whole script?',
  },
  rewriteAllText: {
    id: 'app.sml.musicVideo.directed.script.rewriteAllText',
    defaultMessage:
      'The director writes all shots again from the story and the style. Your edits to the shots are lost. This uses one director run.',
  },
  rewriteAllNote: {
    id: 'app.sml.musicVideo.directed.script.rewriteAllNote',
    defaultMessage: 'Note: more shots of Mara, fewer of the car',
  },
  rewriteAllConfirm: {
    id: 'app.sml.musicVideo.directed.script.rewriteAllConfirm',
    defaultMessage: 'Rewrite the script',
  },
});
